/**
 * Created by razial on 04.06.2025.
 */

Meta.GetAvailableLocations = function () {
    return {
        "0": {
            id: 0,
            slotId: Meta.SLOT_MAIN,
            locationType: "hose",
            usesStars: true,
            retire: false
        }
    };
};
